import React, { useState } from 'react';
import { SubmissionStatus, submissionStatusLabel } from '../../../models/assignments';
import { TextArea } from '../../../components/UI/TextArea/TextArea';
import { Button } from '../../../components/UI/Button/Button';

interface GradeFormProps {
  status: SubmissionStatus;
  feedback: string;
  gradedAt: string | null;
  disabled?: boolean;
  onGrade: (_req: { status: 'accepted' | 'rejected'; feedback: string }) => void;
}

export const GradeForm = ({
  status,
  feedback,
  gradedAt,
  disabled,
  onGrade,
}: GradeFormProps): JSX.Element => {
  const [comment, setComment] = useState(feedback);

  if (status !== 'pending') {
    return (
      <div>
        <div>Статус: {submissionStatusLabel(status)}</div>
        <div>
          Проверено: {gradedAt ? new Date(gradedAt).toLocaleString('ru-RU') : '—'}
        </div>
        <div>Комментарий: {feedback || 'без комментария'}</div>
      </div>
    );
  }

  const handleGrade = (nextStatus: 'accepted' | 'rejected'): void => {
    const message = nextStatus === 'accepted' ? 'Принять работу?' : 'Отклонить работу?';
    if (window.confirm(message)) {
      onGrade({ status: nextStatus, feedback: comment });
    }
  };

  return (
    <div>
      <TextArea
        textLabel="Комментарий"
        aria-label="Комментарий"
        value={comment}
        onChange={(event) => setComment(event.target.value)}
      />
      <Button appearance="auth" disabled={disabled} onClick={() => handleGrade('accepted')}>
        Принять
      </Button>
      <Button appearance="back" disabled={disabled} onClick={() => handleGrade('rejected')}>
        Отклонить
      </Button>
    </div>
  );
};

export default GradeForm;
